/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconClockBolt = createReactComponent("clock-bolt", "IconClockBolt", [
  ["path", { d: "M20.984 12.53a9 9 0 1 0 -7.552 8.355", key: "svg-0" }],
  ["path", { d: "M12 7v5l3 3", key: "svg-1" }],
  ["path", { d: "M19 16l-2 3h4l-2 3", key: "svg-2" }]
]);

export { IconClockBolt as default };
//# sourceMappingURL=IconClockBolt.js.map
